export function getDiscountPercentage(originalPrice?: number, discountedPrice?: number): number | null {
  if (!originalPrice || !discountedPrice) {
    return null;
  }

  return Math.round(((originalPrice - discountedPrice) / originalPrice) * 100);
}
